module.exports = __webpack_public_path__ + "img/pop.7f676074.png";